// BOORO: the language a person reads BOORO in, reported by the apps so the
// server writes notices, mails and the log in it too.
import { PRODUCT_LOCALES } from "@booro/locale";
import { oc } from "@orpc/contract";
import * as z from "zod";

export const ProductLocaleSchema = z.enum(PRODUCT_LOCALES);

export const booroLocaleContract = {
  set: oc.input(z.object({ locale: ProductLocaleSchema })),
};
